<h3 data-bb="title">{{ 'tokens.browser.logout.title' | apContent }}</h3>

<div data-bb="description" class="ap-margin-bottom-4 ap-display-block">{{ 'tokens.browser.logout.description' | apContent }}</div>

<ap-button (onClick)="onRegisterBrowser()" data-bb="register-browser">
    {{ 'tokens.browser.logout.registerBrowser' | apContent }}
</ap-button>

<ap-button (onClick)="onCancel()" data-bb="cancel" variant="secondary">
    {{ 'tokens.browser.logout.cancel' | apContent }}
</ap-button>
